<template>
  <div class="pa-6">
    <Loader :messageSelector="messageSelector" :overlay="overlay" />

    <v-form ref="form" v-model="valid">
      <fieldset>
        <legend class="text-h6 text-sm-h5">Détails relatifs à votre paiement de cotisation</legend>

        <RessourceInfoBulle code="RE-OP-1" />

        <v-autocomplete
          v-model="statutEmploi.modeDeReglement"
          :item-text="itemText"
          :item-value="itemValue"
          :items="getModesDeReglement"
          :rules="rules.modeReglement"
          class="cssRequired"
          label="Mode de règlement"
          required
          return-object
        ></v-autocomplete>
      </fieldset>
    </v-form>
    <div class="text-center mt-6 d-flex justify-space-between">
      <v-btn color="primary" @click="back()">Retour</v-btn>
      <v-btn :disabled="!valid" color="primary" @click="saveAndContinue()">Suivant</v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import Loader from "../Loader"
import NavigationPageFormulaireInscriptionMixin from "@/mixins/navigationPageFormulaireInscriptionMixin"

// page isDroitsAcquis
// todo revoir la gestion de la validation sans le launchValidation!
export default {
  mixins: [NavigationPageFormulaireInscriptionMixin],
  props: {
    routeName: {
      type: String,
      default: ""
    }
  },
  components: {
    Loader: Loader
  },
  data() {
    return {
      overlay: false,
      messageSelector: "",
      valid: true,
      choixAssurance: [],
      rules: {
        modeReglement: [(v) => !this.launchValidation || (!!v && v.length != 0) || "Le mode de paiement est requise"]
      },
      launchValidation: false
    }
  },
  computed: {
    ...mapGetters({
      demandeInscriptionId: "DemandeInscription/GET_DEMANDEINSCRIPTIONID",
      statutEmploi: "StatutEmploi/getStatutEmploi",
      getModesDeReglement: "Catalogue/getModesDeReglement"
    })
  },
  created() {
    this.fetchItems()
  },
  methods: {
    ...mapActions({
      getCatalogue: "Catalogue/getCatalogue",
      getStatutEmploiByDemandeInscriptionId: "StatutEmploi/getStatutEmploiByDemandeInscriptionId",
      updateStatutEmploi: "StatutEmploi/updateStatutEmploi"
    }),
    async fetchItems() {
      try {
        this.messageSelector = "Loading"
        this.overlay = true

        // Mode de règlement
        await this.getCatalogue(2928)

        if (this.demandeInscriptionId) {
          await this.getStatutEmploiByDemandeInscriptionId(this.demandeInscriptionId)
        }

        this.overlay = false
      } catch (erreur) {
        console.log(erreur)
      }
    },
    saveAndContinue() {
      this.save()
    },
    async save() {
      this.messageSelector = "Save"
      this.overlay = true
      this.launchValidation = true
      this.valid = this.$refs.form.validate()

      if (this.valid) {
        try {
          await this.updateStatutEmploi(this.statutEmploi)
          this.overlay = false
          this.next()
        } catch (err) {
          console.log(err)
        }
      }
      this.overlay = false
    },
    itemText: (item) => item.lang00,
    itemValue: (item) => item.id,
    validateForm() {
      this.$refs.form.validate()
    }
  }
}
</script>

<style></style>
